export const locations = [
  {
    country: 'italy',
    city: 'rome',
    countryCode: 'IT',
    lat: 41.9028,
    lng: 12.4964,
  },
  {
    country: 'poland',
    city: 'warsaw',
    countryCode: 'PL',
    lat: 52.244090,
    lng: 21.002239,
  },
  {
    country: 'poland',
    city: 'gdansk',
    countryCode: 'PL',
    lat: 54.352000,
    lng: 18.646600,
  },
  {
    country: 'poland',
    city: 'krakow',
    countryCode: 'PL',
    lat: 50.064700,
    lng: 19.945000,
  },
  {
    country: 'switzerland',
    city: 'zurich',
    countryCode: 'CH',
    lat: 47.3769,
    lng: 8.5417,
  },
  {
    country: 'netherlands',
    city: 'utrecht',
    countryCode: 'NL',
    lat: 52.0907,
    lng: 5.1214,
  },
  {
    country: 'netherlands',
    city: 'rotterdam',
    countryCode: 'NL',
    lat: 51.9244,
    lng: 4.4777,
  },
  {
    country: 'netherlands',
    city: 'amsterdam',
    countryCode: 'NL',
    lat: 51.9244,
    lng: 4.4777,
  },
  {
    country: 'france',
    city: 'nice',
    countryCode: 'FR',
    lat: 43.7102,
    lng: 7.2620,
  },
  {
    country: 'ireland',
    city: 'dublin',
    countryCode: 'IE',
    lat: 53.3948,
    lng: -6.2603,
  },
  {
    country: 'usa',
    city: 'austin',
    countryCode: 'US',
    lat: 30.2672,
    lng: -97.7431,
  },
  {
    country: 'portugal',
    city: 'lisbon',
    countryCode: 'PT',
    lat: 38.7223,
    lng: -9.1393,
  },
  {
    country: 'uk',
    city: 'london',
    countryCode: 'GB',
    lat: 51.5074,
    lng: -0.1278,
  },
  {
    country: 'france',
    city: 'paris',
    countryCode: 'FR',
    lat: 48.8566,
    lng: 2.3522,
  },
  {
    country: 'switzerland',
    city: 'geneva',
    countryCode: 'CH',
    lat: 46.2044,
    lng: 6.1432,
  },
  {
    country: 'spain',
    city: 'barcelona',
    countryCode: 'ES',
    lat: 41.3874,
    lng: 2.1686,
  },
  {
    country: 'usa',
    city: 'chicago',
    countryCode: 'US',
    lat: 41.8781,
    lng: -87.6298,
  },
  {
    country: 'usa',
    city: 'tulsa',
    countryCode: 'US',
    lat: 36.1540,
    lng: -95.9928,
  },
  {
    country: 'usa',
    city: 'tampa',
    countryCode: 'US',
    lat: 27.9506,
    lng: -82.4572,
  },
  {
    country: 'usa',
    city: 'washington',
    countryCode: 'US',
    lat: 38.9072,
    lng: -77.0369,
  },
  {
    country: 'usa',
    city: 'providence',
    countryCode: 'US',
    lat: 41.8240,
    lng: -71.4128,
  },
  {
    country: 'usa',
    city: 'newYork',
    countryCode: 'US',
    lat: 40.7128,
    lng: -74.0060,
  },
  {
    country: 'usa',
    city: 'houston',
    countryCode: 'US',
    lat: 29.7604,
    lng: -95.3698,
  },
  {
    country: 'usa',
    city: 'phoenix',
    countryCode: 'US',
    lat: 33.4484,
    lng: -112.0740,
  },
  {
    country: 'usa',
    city: 'losAngeles',
    countryCode: 'US',
    lat: 34.0522,
    lng: -118.2437,
  },
  {
    country: 'usa',
    city: 'sanDiego',
    countryCode: 'US',
    lat: 32.7157,
    lng: -117.1611,
  },
  {
    country: 'usa',
    city: 'seattle',
    countryCode: 'US',
    lat: 47.6062,
    lng: -122.3321,
  },
  {
    country: 'usa',
    city: 'charlotte',
    countryCode: 'US',
    lat: 35.2271,
    lng: -80.8431,
  },
  {
    country: 'usa',
    city: 'raleigh',
    countryCode: 'US',
    lat: 35.7796,
    lng: -78.6382,
  },
  {
    country: 'usa',
    city: 'nashville',
    countryCode: 'US',
    lat: 36.1627,
    lng: -86.7816,
  },
  {
    country: 'usa',
    city: 'columbus',
    countryCode: 'US',
    lat: 39.9612,
    lng: -82.9988,
  },
  {
    country: 'usa',
    city: 'denver',
    countryCode: 'US',
    lat: 39.7392,
    lng: -104.9903,
  },
  {
    country: 'usa',
    city: 'minneapolis',
    countryCode: 'US',
    lat: 44.9778,
    lng: -93.2650,
  },
  {
    country: 'usa',
    city: 'lasVegas',
    countryCode: 'US',
    lat: 36.1699,
    lng: -115.1398,
  },
];
export const locationsObject = locations.reduce((prev, next) => {
  prev[next.city] = next;
  return prev;
}, {} as Record<string, typeof locations[0]>);
